/**
 * Plain-text article titles only — strip common markdown when pasting/typing in title field.
 */
export function stripMarkdownFromTitle(str) {
  if (str == null || typeof str !== 'string') return '';
  let s = str;

  s = s.replace(/```[\s\S]*?```/g, '');
  s = s.replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1');
  s = s.replace(/\[([^\]]*)\]\([^)]*\)/g, '$1');
  s = s.replace(/~~(.+?)~~/g, '$1');
  s = s.replace(/\*{3,}(.+?)\*{3,}/g, '$1');
  s = s.replace(/\*{2}(.+?)\*{2}/g, '$1');
  s = s.replace(/__(.+?)__/g, '$1');
  s = s.replace(/\*(.+?)\*/g, '$1');
  s = s.replace(/_(.+?)_/g, '$1');
  s = s.replace(/^#{1,6}\s+/gm, '');
  s = s.replace(/`([^`]*)`/g, '$1');
  s = s.replace(/^>\s?/gm, '');
  s = s.replace(/^[-*_]{3,}\s*$/gm, '');
  s = s.replace(/^\s*[-*+]\s+/gm, '');
  s = s.replace(/^\s*\d+\.\s+/gm, '');
  s = s.replace(/<[^>]+>/g, '');
  s = s.replace(/[`*_~#>]/g, '');
  s = s.replace(/\s+/g, ' ');
  s = s.replace(/^\s+/, '');

  return s;
}
